(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["build-your-ritual"] && !Shopify.designMode) return;
  try {
    
(() => {
  const recipes = {
    calm:{name:'Grounded Evening Ritual',taste:'soft floral, fresh, lightly aromatic',synergy:'Chamomile and lemon balm form a soft aromatic base, spearmint lifts the cup, and lavender is kept low so the floral note stays balanced.',items:[['Chamomile',40],['Lemon Balm',30],['Spearmint',20],['Lavender',10]]},
    morning:{name:'Bright Morning Ritual',taste:'green, fresh, warming',synergy:'Moringa creates the green foundation, spearmint brightens it, ginger adds warmth, and rosemary gives an aromatic finish.',items:[['Moringa',45],['Spearmint',25],['Ginger',20],['Rosemary',10]]},
    digestive:{name:'After-Meal Ease Ritual',taste:'minty, sweet-aromatic, warming',synergy:'Spearmint and fennel build a cool-sweet aromatic base, ginger adds warmth, and chamomile softens the edges.',items:[['Spearmint',35],['Ginger',30],['Fennel',25],['Chamomile',10]]},
    nourish:{name:'Green Renewal Ritual',taste:'earthy green, fresh, lightly tart',synergy:'Nettle and moringa make the cup deeply green and earthy, while spearmint and hibiscus bring lift and brightness.',items:[['Nettle Leaf',45],['Moringa',30],['Spearmint',15],['Hibiscus',10]]},
    women:{name:'Rooted Her Ritual',taste:'leafy, tart, gently warming',synergy:'Raspberry leaf and nettle create a leafy base, hibiscus adds tart color, and ginger adds a warming finish.',items:[['Raspberry Leaf',40],['Nettle Leaf',30],['Hibiscus',20],['Ginger',10]]},
    men:{name:'Rooted Strength Ritual',taste:'earthy, malty, warm-spiced',synergy:'Maca and moringa form an earthy base, ginger adds warmth, and cinnamon rounds the cup with sweet spice.',items:[['Maca',35],['Moringa',30],['Ginger',20],['Cinnamon',15]]},
    seasonal:{name:'Seasonal Hearth Ritual',taste:'berry-rich, tart, warm-spiced',synergy:'Elderberry and hibiscus make a deep fruity-tart base, while ginger and cinnamon bring warming spice.',items:[['Elderberry',40],['Hibiscus',25],['Ginger',20],['Cinnamon',15]]}
  };
  const flavorAccents={floral:'Lavender',fresh:'Spearmint',warming:'Ginger',earthy:'Nettle Leaf',tart:'Hibiscus'};
  const flavorLabels={floral:'Floral & Soft',fresh:'Fresh & Minty',warming:'Warming & Spiced',earthy:'Earthy & Grounding',tart:'Tart & Fruity'};
  const gramsPerOunce=28.3495;

  document.querySelectorAll('.beg-ritual-builder').forEach(root => {
    if(root.dataset.begReady==='true') return;
    root.dataset.begReady='true';
    const form=root.querySelector('.beg-builder-form');
    const result=root.querySelector('.beg-builder-result');
    const tbody=root.querySelector('.beg-result-table tbody');
    const accentNote=root.querySelector('.beg-accent-note');
    const safetyMessage=root.querySelector('.beg-safety-message');
    const copyStatus=root.querySelector('.beg-copy-status');
    let latestRecipe='';

    const buildBlend=(base,accent)=>{
      const items=base.items.map(([name,pct])=>[name,pct]);
      if(items.some(([name])=>name===accent)) return {items,changed:false};
      let topIndex=0;
      items.forEach((item,index)=>{if(item[1]>items[topIndex][1]) topIndex=index;});
      items[topIndex][1]-=10;
      items.push([accent,10]);
      return {items,changed:true};
    };

    form.addEventListener('submit',event=>{
      event.preventDefault();
      const ritual=form.querySelector('input[name="ritual"]:checked')?.value;
      const flavor=form.querySelector('input[name="flavor"]:checked')?.value;
      const size=Number(form.querySelector('input[name="size"]:checked')?.value || 2);
      if(!ritual || !flavor || !recipes[ritual]) return;

      const base=recipes[ritual];
      const accent=flavorAccents[flavor];
      const built=buildBlend(base,accent);
      root.querySelector('.beg-result-name').textContent=base.name;
      root.querySelector('.beg-result-taste').textContent='Taste direction: '+flavorLabels[flavor]+' • '+base.taste;
      root.querySelector('.beg-result-synergy').textContent=base.synergy;

      tbody.innerHTML='';
      const recipeLines=[];
      built.items.forEach(([name,pct])=>{
        const oz=size*(pct/100);
        const grams=oz*gramsPerOunce;
        recipeLines.push(name+' — '+pct+'% — '+oz.toFixed(2)+' oz — '+grams.toFixed(1)+' g');
        const row=document.createElement('tr');
        row.innerHTML='<td class="beg-herb-cell"><div class="beg-herb-name"></div><div class="beg-bar"><span></span></div></td><td class="beg-pct"></td><td class="beg-oz"></td><td class="beg-grams"></td>';
        row.querySelector('.beg-herb-name').textContent=name;
        row.querySelector('.beg-bar span').style.width=pct+'%';
        row.querySelector('.beg-pct').textContent=pct+'%';
        row.querySelector('.beg-oz').textContent=oz.toFixed(2)+' oz';
        row.querySelector('.beg-grams').textContent=grams.toFixed(1)+' g';
        tbody.appendChild(row);
      });

      if(built.changed){accentNote.hidden=false;accentNote.textContent='Flavor adjustment: '+accent+' is added as a 10% accent while the full blend remains at 100%.';}else{accentNote.hidden=true;accentNote.textContent='';}

      const selectedSafety=[...form.querySelectorAll('input[name="safety"]:checked')].map(input=>input.value);
      safetyMessage.textContent=selectedSafety.length
        ? 'You selected one or more safety considerations. Treat this recipe as educational only until a qualified healthcare professional or pharmacist familiar with your medications and health history reviews the full ingredient list.'
        : 'Review each herb’s Know Before You Sip notes before use, and re-check them whenever medications, allergies, pregnancy status, surgery plans, or health conditions change.';

      latestRecipe='BLACK EARTHY GIRL — '+base.name+'\n'+size+' oz total\nTaste: '+flavorLabels[flavor]+'\n\n'+recipeLines.join('\n')+'\n\nEducational use only. Review each botanical in The Herbal before use.';
      copyStatus.textContent='';
      result.hidden=false;
      result.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
    });

    root.querySelector('.beg-copy').addEventListener('click',async()=>{
      if(!latestRecipe) return;
      try{await navigator.clipboard.writeText(latestRecipe);copyStatus.textContent='Recipe copied — save it in your notes or send it to yourself.';}catch(e){copyStatus.textContent='Copy is not available in this browser. You can still screenshot your recipe.';}
    });

    root.querySelector('.beg-reset').addEventListener('click',()=>{
      form.reset();
      const calm=form.querySelector('input[name="ritual"][value="calm"]');
      const floral=form.querySelector('input[name="flavor"][value="floral"]');
      const two=form.querySelector('input[name="size"][value="2"]');
      if(calm) calm.checked=true;if(floral) floral.checked=true;if(two) two.checked=true;
      result.hidden=true;latestRecipe='';copyStatus.textContent='';
      form.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
